import React, { FC, useState, useEffect, useRef, useCallback } from 'react';
import { differenceInSeconds } from 'date-fns';
import cns from 'classnames';

import { MAX_ATTEMPTS_CODE_REACHED } from 'constants/errors';
import styles from './ResendCode.module.scss';

interface Props {
  onSubmit: () => Promise<any>;
  endTime: Date;
}

export const ResendCode: FC<Props> = ({ onSubmit, endTime }) => {
  const timer = useRef<ReturnType<typeof setInterval>>();
  const [seconds, setSeconds] = useState<number | null>(null); // seconds
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      await onSubmit();
    } catch (e: any) {
      if (e?.data?.message === 'max_attempts_reached') {
        setError(MAX_ATTEMPTS_CODE_REACHED);
      } else {
        setError('Ошибка');
      }
    } finally {
      setSubmitting(false);
    }
  };

  const calc = useCallback(() => {
    const diff = differenceInSeconds(endTime, new Date());
    if (diff > 0) {
      setSeconds(diff);
      return;
    }
    clearInterval(timer.current);
    setSeconds(null);
  }, [endTime]);

  useEffect(() => {
    calc();
    timer.current = setInterval(calc, 1000);
    return () => {
      clearInterval(timer.current);
    };
  }, [calc]);

  if (error) {
    return <div className={cns(styles.text, styles.error)}>{error}</div>;
  }

  if (submitting) {
    return <div className={styles.text}>Отправляем...</div>;
  }

  return (
    seconds
      ? <div className={styles.text}>Запросить код повторно можно через {seconds} секунд</div>
      : (<div
          className={cns(styles.text, styles.pointer)}
          role="button"
          tabIndex={0}
          onClick={handleSubmit}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              handleSubmit();
            }
          }}
        >Отправить код повторно</div>
      )
  );
};
